/**
 * Step 10 — World View & Experience
 *
 * Fields: viewOnAnimalCruelty, viewOnLgbtqStatements,
 * viewOnTransgenderInclusion, facingCasteDiscrimination,
 * casteDiscriminationPlaces, viewOnGenderEquality
 *
 * @module udp-schema/step-10
 */

import { z } from 'zod';

// ─── Main Step 10 Schema ────────────────────────────────────────────────────

export const step10WorldViewSchema = z.object({
  /** View on animal cruelty */
  viewOnAnimalCruelty: z
    .enum([
      'strongly_against',
      'against_but_food',
      'neutral',
      'acceptable_in_tradition',
      'prefer_not_to_say',
    ])
    .optional(),

  /** LGBTQ+ views — multi-select statements (reused from existing UDP) */
  viewOnLgbtqStatements: z.array(z.string().trim()).optional(),

  /** Transgender inclusion — multi-select statements (reused from existing UDP) */
  viewOnTransgenderInclusion: z.array(z.string().trim()).optional(),

  /** Facing caste-based discrimination */
  facingCasteDiscrimination: z
    .enum(['YES_OFTEN', 'YES_SOMETIMES', 'NO', 'PREFER_NOT_SAY'])
    .optional(),

  /** Places where caste discrimination is faced (multi-select) */
  casteDiscriminationPlaces: z.array(z.string().trim()).optional(),

  /** View on gender equality */
  viewOnGenderEquality: z
    .enum([
      'strong_advocate',
      'supportive',
      'traditional_values',
      'no_opinion',
      'prefer_not_to_say',
    ])
    .optional(),
});

// ─── Inferred types ─────────────────────────────────────────────────────────

export type Step10WorldViewInput = z.infer<typeof step10WorldViewSchema>;
